import useSWR from 'swr'
import { FetchResponse } from 'utils/fetcher'
import { ApiType } from 'utils/types'
import { apiAuthFetcher } from 'api/goodtrust/api'
import { getDirectiveKey } from './utils'

export function useUserPet(uuid: string) {
  return useSWR<FetchResponse<ApiType['UserDirectivePetResponse']>>(
    uuid ? getDirectiveKey(uuid, 'PET') : null,
    apiAuthFetcher,
    { revalidateOnFocus: false }
  )
}

export function postUserPetFinish(uuid: string) {
  return apiAuthFetcher<ApiType['UserDirectiveResponse']>(
    `${getDirectiveKey(uuid, 'PET')}/finish`,
    {
      method: 'POST',
    }
  )
}

export function downloadUserPet(uuid: string) {
  return apiAuthFetcher(`${getDirectiveKey(uuid, 'PET')}/generate`, {
    toBlob: true,
    noThrowOnError: true,
  })
}
